<template>
    <v-app-bar
        class="sek-header"
        app
        fixed
        flat
        color="transparent"
        dark>
        <v-btn
            text
            @click="changeDrawer"
            id="mobile">
            <v-icon>mdi-menu</v-icon>
        </v-btn>
        <div class="d-flex align-center">
            <v-img
                @click="goTo({name: 'HomePage'})"
                alt="Vuetify Logo"
                class="sek-logo shrink mr-2"
                contain
                :src="logoImg"
                transition="scale-transition" />
        </div>

        <div
            class="sek-header-nav">
            <a
                v-for="(item, index) in navItems"
                :key="index"
                :href="item.section"
                class="sek-header-nav-item"
                @click="goTo(item.section)">
                <span>
                    {{ item.name }}
                </span>
            </a>
        </div>

        <circular-button
            outlined
            @click="goTo({name: 'parceiro'})"
            class="sek-header-assessorados">
            Assessorados
        </circular-button>

    </v-app-bar>
</template>

<script>
import CircularButton from "../utils/CircularButton.vue";

export default {
    components: {
        "circular-button": CircularButton
    },
    data() {
        return {
            logoImg: require("@/assets/images/sek-nav.png"),
            navItems: [
                { section: "#quem-somos", name: "Quem somos?" },
                { section: "#seguros", name: "Seguros" },
                { section: "#parceiros", name: "Parceiros" },
                { section: "#blog", name: "Blog" },
                { section: "#contato", name: "Contato" },
            ]
        }
    },
    methods: {
        goTo(opts) {
            this.$router.push(opts)
        },
        changeDrawer() {
            this.$emit('changeDrawer', true)
        }
    }
}
</script>

<style lang="scss">
.sek-header {
    height: 130px !important;

    #mobile {
        display: none;
    }

    &.v-app-bar--is-scrolled, &.is-scrolled {
        height: 70px !important;

        .sek-logo {
            height: 50px;
            width: 100;
            margin-top: 0;
        }

        .v-toolbar__content {
            background: black;
            box-shadow: 0 1px 6px 0 rgb(32 33 36 / 28%);
        }

    }
    .sek-logo {
        width: 241px;
        height: 88px;
        margin-left: 90px;
        margin-top: 35px;
        transition: all 0.2s ease;
        cursor: pointer;
    }

     .v-toolbar__content {
        transition: all 0.2s ease;
     }

    .sek-header-nav {
        margin-left: 180px;
        align-self: flex-start;

        .sek-header-nav-item {
            padding: 0 25px;
            height: 60px;
            color: $c-white;
            text-decoration: none;
            display: inline-flex;
            align-items: center;

            &:hover {
                span {
                    &::before {
                        transform: scaleX(1);
                        opacity: 1;
                    }
                }
            } 
            
            span {
                font-size: 16px;
                font-weight: bold;
                position: relative;
                
                &::before {
                    content: "";
                    width: 100%;
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    opacity: 0;
                    background: $c-white;
                    transform: scaleX(0.3);
                    transition: all 0.25s ease-out;
                }
            }
        }

    }

    .sek-header-assessorados {
        align-self: flex-start;
        margin-top: 12px;
        margin-left: 59px;
        background-color: transparent;
        color: $c-secondary;

        border-width: 2px;

        .v-btn__content {
            color: $c-white !important;
            font-size: 16px !important;
            font-weight: bold !important;
        }
    }
}

@media screen and (max-width: 480px) {
    #mobile {
        display: block !important;
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);

    }
}
</style>